import { useEffect, useState } from "react";
import { _PortfolioDeterioration, _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean"
import { BasicPage } from "../../../../../theme/Component/BasicPage"
import { BasicTable, MASK_DECIMAL, MASK_NUMBER } from "../../../../../theme/Component/BasicTable";
import { ListMenu } from "../../../../../theme/Component/ListMenu";
import useModal, { MODAL_md } from "../../../../../theme/Component/hooks/useModal";
import { Modal } from "../../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../../theme/Component/ModalConfirm";

export const PortfolioDeterioration = () => {

    const _portfolio = useDataBean(_PortfolioDeterioration);
    const { bean, setBean, lista, setLista, instance,handleChange } = _portfolio;
    const modalEdit = useModal("Editar", MODAL_md);
    const modalDelete = useModal("Eliminar", MODAL_md);

    useEffect(() => {
        _portfolio.getLista({ State: 1 }, null);
    }, [])

    const head = [
        { title: 'ID', property: 'IDPortfolioDeterioration', visible: false, mask: MASK_NUMBER },
        { title: 'Calificación', property: 'Rating', visible: true },
        { title: 'Clasificación de riesgo', property: 'RiskClassification', visible: true },        
        { title: 'Dia inicial Vencimiento', property: 'StartDaysOverdue', visible: true },
        { title: 'Dia final Vencimiento', property: 'EndDaysOverdue', visible: true },
        { title: '% Deterioro Capital', property: 'CapitalDeteriorationRate', visible: true,mask:MASK_DECIMAL },
        { title: '% Deterioro Interes', property: 'InterestDeteriorationRate', visible: true,mask:MASK_DECIMAL },
    ]


    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-file-add-line', visible: _single.canEdit(), evento: () => { modalEdit.open(); setBean({...bean,State:1,IDEmployee:_single.getAccountID()})} },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { modalDelete.open()} },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }
    const agregar = ()=>{
        setBean({
            State:1,
            IDEmployee:_single.getAccountID()
        });
        modalEdit.open();
    }
    const editar = ()=>{
        _portfolio.update().then(
            (resp:any)=>{
                _portfolio.getLista({State:1},null);
                modalEdit.close();
            }
        )
    }
    const eliminar = ()=>{
        _portfolio.deleteItem(bean.IDPortfolioDeterioration).then(
            (resp:any)=>{
                _portfolio.getLista({State:1},null);
            }
        )
    }
    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: agregar }
    ]

    return (
        <BasicPage titulo="Parametros Deterioro de Cartera">
            <div className="row">
                <div className="col">
                    <BasicTable body={lista} head={head} rowSet={setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modalEdit.modal} updateModal={modalEdit.setModal} eventModal={editar}>
                        <div className="row">
                            <div className="col-md-4">
                                <label>Calificación</label>
                                <input type="text" name="Rating" id="Rating" className="form-control" value={bean.Rating}  onChange={handleChange}/>
                            </div>
                            <div className="col-md-4">
                                <label>Dias Deterioro inicial</label>
                                <input type="number" name="StartDaysOverdue" id="StartDaysOverdue" value={bean.StartDaysOverdue} className="form-control"  onChange={handleChange}/>
                            </div>
                            <div className="col-md-4">
                                <label>Dias Deterioro Final</label>
                                <input type="number" name="EndDaysOverdue" id="EndDaysOverdue"  value={bean.EndDaysOverdue} className="form-control"  onChange={handleChange}/>
                            </div>
                            <div className="col-md-12">
                                <label>Clasificación del Riesgo</label>
                                <input type="text" name="RiskClassification" id="RiskClassification" value={bean.RiskClassification} className="form-control"  onChange={handleChange}/>
                            </div>
                            <div className="col-md-4">
                                <label>% Deterioro Capital</label>
                                <input type="number" name="CapitalDeteriorationRate" id="CapitalDeteriorationRate" value={bean.CapitalDeteriorationRate} className="form-control"  onChange={handleChange}/>
                            </div>
                            <div className="col-md-4">
                                <label>% Deterioro Interes</label>
                                <input type="number" name="InterestDeteriorationRate" id="InterestDeteriorationRate" value={bean.InterestDeteriorationRate} className="form-control"  onChange={handleChange}/>
                            </div>
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalDelete.modal} updateModal={modalDelete.setModal} eventModal={eliminar}>
                        <p>Eliminar Item</p>
                    </ModalConfirm>
                </div>
            </div>
        </BasicPage>
    )
}